/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { SdsIcon } from '../../../SdsIcon';
import { DropdownItemProps } from './DropdownItem.props';

/**
 * SDS Dropdown item component.
 */
export const DropdownItem = (props: DropdownItemProps): JSX.Element => {
  const { accessibleProps, closeDropdown, dropdownItem } = props;
  const { action, dataID, icon, isDisabled, label, ...rest } = dropdownItem;

  const onItemClick = (): void => {
    if (action) {
      action();
    }
    closeDropdown();
  };

  return (
    <li data-id={dataID} role="none" {...rest}>
      <button
        {...accessibleProps}
        className="sds-dropdown-button"
        disabled={isDisabled}
        onClick={(event): void => {
          event.preventDefault();
          onItemClick();
        }}
        role="menuitem"
      >
        {icon && (
          <div className="sds-dropdown-icon">
            <SdsIcon svg={icon} />
          </div>
        )}
        <span className="sds-dropdown-label">{label}</span>
      </button>
    </li>
  );
};
